import React, { Component } from 'react'
import { connect } from "react-redux";
import _ from 'lodash';
import {buildPrepTime} from '../../globals';
import '../../css/common.css';
import '../../css/recipe_page.css';

class RecipePage extends Component {
  
    componentDidMount() {
    }
    
    listIngred(ingred, evenrow) {
        var rowClass = "";
        rowClass = evenrow === true ? "ingred-row" : "ingred-row ultra-ultra-light-bk";
        return (
            <div key={ingred.Item_Id} className={rowClass}>
                <div className="ingred-row-qty"><div>{ingred.Quantity}</div></div>
                <div className="ingred-row-measure">{ingred.Measurement}</div>
                <div className="ingred-row-name">{ingred.Item_Name}</div>
            </div>
        );
    }

    listIngreds() {
        var evenrow = false;
        return _.map(this.props.recipe.Ingredients, ingred => {
            evenrow = !evenrow;
            return this.listIngred(ingred, evenrow);
        });
    }

    listCategories(cats) {
        var lst = "";
        _.map(cats, cat => {
            lst = lst + cat + ", ";
        });
        console.log(lst);
        if (lst.length > 1) {
            return lst.substring(0, lst.length - 2);
        }      
        else {
            return "";
        }  
    }

    render() {
    
        return (
            <div id="main" className="med-bk">
                <div id="divHeader">
                    <div id="divHeaderLeft" className="ultra-ultra-light-bk main-font">
                        <div className="divHeaderLeftRow">
                            <div className="divHeaderLeftLabel"><div>Category</div></div>
                            <div className="divHeaderLeftData bold>">{this.listCategories(this.props.recipe.Categories)}</div>
                        </div>
                        <div className="divHeaderLeftRow">
                            <div className="divHeaderLeftLabel">Servings</div>
                            <div className="divHeaderLeftData bold>">{this.props.recipe.Servings}</div>
                        </div>
                        <div className="divHeaderLeftRow">
                            <div className="divHeaderLeftLabel">Cook Time</div>
                            <div className="divHeaderLeftData bold>">{buildPrepTime(this.props.recipe.Cook_Minutes)}</div>
                        </div>
                        <div className="divHeaderLeftRow">
                            <div className="divHeaderLeftLabel">Prep Time</div>
                            <div className="divHeaderLeftData bold>">{buildPrepTime(this.props.recipe.Prep_Minutes)}</div>
                        </div>
                        <div className="divHeaderLeftRow">
                            <div className="divHeaderLeftLabel">Source</div>
                            <div className="divHeaderLeftData bold>">{this.props.recipe.Source}</div>
                        </div>
                    </div>
                    <div id="divHeaderRight">
                        <img id="imgRecipeImages" alt="" title="Recipe Image(s)" src={this.props.recipe.ImageUrls[0]} />
                    </div>
                </div>
                <div id="divContentArea"  className="">
                    <div id="divContentAreaInner">
                        <div id="divName" className="">
                            {this.props.recipe.Name}
                        </div>
                        <div id="divInstructions" className="grn-brdr main-font">
                            {this.props.recipe.Directions}
                        </div>
                        <div id="divIngredients" className="grn-brdr main-font">
                            {this.listIngreds()}
                        </div>
                    </div>
                </div>
            </div>
        )
        
    }
}

function mapStateToProps(state) {
    return { recipe: state.recipes.current_recipe };
};
    
export default connect(mapStateToProps)(RecipePage);


// WEBPACK FOOTER //
// ./src/pages/recipe/recipe_page.js